var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseGridCardVertical",
    _vm._g(
      _vm._b(
        {
          staticClass: "base-product-grid-card",
          scopedSlots: _vm._u(
            [
              {
                key: "body",
                fn: function () {
                  return [
                    _vm._t("image", function () {
                      return [
                        _vm.imageSrc
                          ? _c("BaseImage", {
                              staticClass: "base-product-grid-card__image",
                              attrs: {
                                alt: _vm.imageAlt,
                                "aspect-ratio": _vm.imageAspectRatio,
                                src: _vm.imageSrc,
                                "placeholder-color-background":
                                  _vm.placeholderColorBackground,
                                "placeholder-color-foreground":
                                  _vm.placeholderColorForeground,
                              },
                            })
                          : _vm._e(),
                      ]
                    }),
                    _vm._v(" "),
                    _vm._t("meta-text", function () {
                      return [
                        _vm.metaText
                          ? _c(
                              "v-card-text",
                              {
                                class: [
                                  "base-product-grid-card__meta-text",
                                  "pt-4 pb-0",
                                  "overline",
                                  _vm.metaTextColor,
                                ],
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.metaText) +
                                    "\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                    _vm._v(" "),
                    _vm._t("title-text", function () {
                      return [
                        _vm.titleText
                          ? _c(
                              "v-card-text",
                              {
                                class: [
                                  "base-product-grid-card__title-text",
                                  "pt-4 mb-3 text-line-clamp-2",
                                  "title",
                                  _vm.titleTextColor,
                                ],
                                staticStyle: { "line-height": "1.3" },
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(_vm.titleText) +
                                    "\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "footer",
                fn: function () {
                  return [
                    _vm._t("footer", function () {
                      return [
                        _vm.footerText ||
                        _vm.wishlistShow ||
                        _vm.$slots["footer-text"] ||
                        _vm.$slots["footer-wishlist"]
                          ? _c(
                              "v-card-actions",
                              {
                                class: [
                                  "base-product-grid-card__footer",
                                  "pt-0 body-2",
                                ],
                              },
                              [
                                _vm._t("footer-text", function () {
                                  return [
                                    _vm.footerText
                                      ? _c(
                                          "span",
                                          {
                                            class: [
                                              "base-product-grid-card__footer-text",

                                              // Using v-btn for it's dimensions within v-card-actions
                                              "v-btn v-btn--text v-size--default reset-btn-text",
                                              _vm.footerTextColor,
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(_vm.footerText) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }),
                                _vm._v(" "),
                                _vm.wishlistShow
                                  ? [
                                      _vm._t("footer-wishlist", function () {
                                        return [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "base-product-grid-card__wishlist-btn",
                                                              attrs: {
                                                                disabled:
                                                                  !_vm
                                                                    .$listeners
                                                                    .wishlistClick ||
                                                                  _vm.wishlistLoading,
                                                                icon: "",
                                                                loading:
                                                                  _vm.wishlistLoading,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.emitWishlistClick.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "base-product-grid-card__wishlist-icon",
                                                                attrs: {
                                                                  color:
                                                                    _vm.wishlistIconColor,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    mdi-" +
                                                                    _vm._s(
                                                                      _vm.wishlist
                                                                        ? _vm.wishlistIcon
                                                                        : _vm.wishlistIcon +
                                                                            "-outline"
                                                                    ) +
                                                                    "\n                  "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3456044966
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "base-product-grid-card__wishlist-tooltip",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.wishlist
                                                          ? _vm.wishlistTextRemove
                                                          : _vm.wishlistTextAdd
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        "BaseGridCardVertical",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }